import api from '@edu-fe/api'

export default {
  name: 'today',
  getCourseList: api.create('/my/daily')
}
